/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bx as Bx,
  rec_Cargando as Cargando,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Nr as Nr,
  rec_Paginacion as Paginacion,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Sn as Sn,
  rec_Yi as Yi,
  rec_Yx as Yx,
  rec_Zx as Zx,
  rec_api as api,
  rec_fC as fC,
  rec_fS as fS,
  rec_hS as hS,
  rec_ii as ii,
  rec_mS as mS,
  rec_obtenerUsuario as obtenerUsuario,
  rec_pS as pS,
  rec_qC as qC,
  rec_qi as qi,
  rec_wr as wr,
  rec_yr as yr,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Aprobaciones() {
  let [e, t] = (0, React.useState)({
      items: [],
      total: 0,
    }),
    [n, r] = (0, React.useState)({
      items: [],
      total: 0,
    }),
    [i, a] = (0, React.useState)(0),
    [o, s] = (0, React.useState)(0),
    [c, l] = (0, React.useState)(!0),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    [h, g] = (0, React.useState)({}),
    { pedirTexto: _ } = Fo(),
    v = Go(),
    y = obtenerUsuario()?.nombre,
    // Sólo la primera carga muestra «Cargando»: las recargas por cambios en vivo
    // eran silenciosas en intención, pero volvían a animar todo (2026-10-09).
    cargo = (0, React.useRef)(!1),
    b = (0, React.useCallback)(async () => {
      cargo.current || l(!0);
      try {
        let e = (e) => {
          (t(e.conformes),
            r(e.solicitudesFecha),
            i > 0 && !e.conformes.items.length && a(i - 1),
            o > 0 && !e.solicitudesFecha.items.length && s(o - 1));
        };
        (e(
          await api(
            `/tareas/pendientes?paginaConformes=${i}&paginaSolicitudes=${o}&tamano=${qC}`,
            {
              alRefrescar: e,
            },
          ),
        ),
          f(``));
      } catch (e) {
        f(e.message);
      } finally {
        ((cargo.current = !0), l(!1));
      }
    }, [i, o]);
  ((0, React.useEffect)(() => {
    b();
  }, [b]),
    (0, React.useEffect)(() => fC(() => b()), [b]));
  async function x(e, t) {
    if (!p) {
      (m(e), f(``));
      try {
        (await t(), await b());
      } catch (e) {
        f(e.message);
      } finally {
        m(null);
      }
    }
  }
  let S = (e) =>
      x(`t${e.id}`, async () => {
        (await api(`/tareas/${e.id}/conforme`, {
          method: `POST`,
          body: JSON.stringify({
            actorNombre: y,
          }),
        }),
          v.logro(`Tarea aprobada`, e.titulo));
      }),
    C = async (e) => {
      let t = await _({
        titulo: `Devolver «${e.titulo}»`,
        mensaje: `${e.asignadoNombre || `El asignado`} va a ver este motivo.`,
        confirmarTexto: `Devolver`,
      });
      t &&
        x(`t${e.id}`, async () => {
          (await api(`/tareas/${e.id}/devolver`, {
            method: `POST`,
            body: JSON.stringify({
              motivo: t,
              actorNombre: y,
            }),
          }),
            v.info(`Devolviste «${e.titulo}» con tu motivo`));
        });
    },
    w = async (e, t, n) => {
      let r = null;
      (!t &&
        ((r = await _({
          titulo: `Rechazar la solicitud`,
          opcional: !0,
          confirmarTexto: `Rechazar`,
        })),
        r === null)) ||
        x(`s${e.id}`, async () => {
          (await api(`/tareas/solicitudes-fecha/${e.id}/resolver`, {
            method: `POST`,
            body: JSON.stringify({
              aprobar: t,
              motivo: r,
              tipoCambio: n,
              actorNombre: y,
            }),
          }),
            t
              ? e.tipo === `CANCELACION`
                ? v.ok(`Tarea cancelada`)
                : v.ok(
                    n === `REPROGRAMACION`
                      ? `Fecha movida, sin atraso`
                      : `Fecha movida, queda el atraso`,
                  )
              : v.info(`Rechazaste el pedido`));
        });
    },
    T = !c && e.total === 0 && n.total === 0;
  return (
    <EstructuraPrincipal
      title={`Aprobaciones`}
      children={
        <div
          className={`flex flex-col gap-6`}
          children={[
            <p
              className={`text-sm text-(--text)`}
              children={`Lo que espera tu decisión: tareas que te mandaron a revisión y pedidos de quienes dependen de vos.`}
            />,
            <EstadoError mensaje={u} onReintentar={b} />,
            c ? (
              <Cargando
                cantidad={3}
                etiqueta={`Cargando lo que espera tu decisión`}
              />
            ) : T ? (
              <div
                className={`animar-entrada rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                children={[
                  <Nr className={`mx-auto h-8 w-8 text-(--success)`} />,
                  <p
                    className={`mt-2 text-sm text-(--text)`}
                    children={`No tenés nada esperando tu aprobación.`}
                  />,
                ]}
              />
            ) : (
              <JSXRuntime.Fragment
                children={[
                  e.total > 0 && (
                    <section
                      className={`flex flex-col gap-2`}
                      children={[
                        <h2
                          className={`text-sm font-semibold uppercase tracking-wide text-(--text)`}
                          children={[`Esperan tu conformidad (`, e.total, `)`]}
                        />,
                        e.items.map((e) => (
                          <div
                            key={e.id}
                            className={`rounded-2xl border border-(--border) bg-(--bg) p-4 animar-entrada flex flex-col gap-3 ${e.conformidadDemorada ? `border-(--error) bg-(--error-bg)` : ``}`}
                            children={[
                              <div
                                className={`min-w-0`}
                                children={[
                                  <Sn
                                    to={mS(e)}
                                    className={`font-medium text-(--text-h) hover:underline`}
                                    children={e.titulo}
                                  />,
                                  <p
                                    className={`mt-1 text-xs text-(--text)`}
                                    children={[
                                      e.asignadoNombre || `El asignado`,
                                      ` la marcó completada`,
                                      e.enRevisionDesde &&
                                        ` el ${pS(e.enRevisionDesde)}`,
                                    ]}
                                  />,
                                  <p
                                    className={`text-xs text-(--text)`}
                                    children={[
                                      hS(e),
                                      e.fechaVencimiento &&
                                        ` · vence ${fS(e.fechaVencimiento)}`,
                                      e.comprobantes?.length > 0 &&
                                        ` · ${e.comprobantes.length} comprobante${e.comprobantes.length > 1 ? `s` : ``}`,
                                    ]}
                                  />,
                                  e.conformidadDemorada && (
                                    <p
                                      className={`mt-1 flex items-center gap-1 text-xs font-medium text-(--error)`}
                                      children={[
                                        (0, JSXRuntime.jsx)(qi, {
                                          className: `h-3.5 w-3.5`,
                                        }),
                                        `Esperando hace `,
                                        e.diasEsperandoConformidad,
                                        ` `,
                                        e.diasEsperandoConformidad === 1
                                          ? `día`
                                          : `días`,
                                      ]}
                                    />
                                  ),
                                ]}
                              />,
                              <div
                                className={`flex flex-wrap items-center gap-2 border-t border-(--border)/60 pt-3`}
                                children={[
                                  <span
                                    className={`rounded-full border px-2 py-0.5 text-[10px] ${Zx(e.prioridad)}`}
                                    children={Yx(e.prioridad)}
                                  />,
                                  <span
                                    className={`mr-auto rounded-full px-2 py-0.5 text-[10px] bg-(--panel) text-(--text)`}
                                    children={`En revisión`}
                                  />,
                                  <button
                                    type={`button`}
                                    disabled={!!p}
                                    onClick={() => C(e)}
                                    className={zo}
                                    children={[
                                      <Yi
                                        className={`mr-1 inline h-3.5 w-3.5`}
                                      />,
                                      ` Devolver`,
                                    ]}
                                  />,
                                  <button
                                    type={`button`}
                                    disabled={!!p}
                                    onClick={() => S(e)}
                                    className={Ro}
                                    children={[
                                      p === `t${e.id}` &&
                                        (0, JSXRuntime.jsx)(ii, {
                                          className: `mr-1 inline h-4 w-4 animate-spin`,
                                        }),
                                      <Nr
                                        className={`mr-1 inline h-3.5 w-3.5`}
                                      />,
                                      ` Dar conformidad`,
                                    ]}
                                  />,
                                ]}
                              />,
                            ]}
                          />
                        )),
                        <Paginacion
                          pagina={i}
                          tamano={qC}
                          total={e.total}
                          onChange={a}
                        />,
                      ]}
                    />
                  ),
                  n.total > 0 && (
                    <section
                      className={`flex flex-col gap-2`}
                      children={[
                        <h2
                          className={`text-sm font-semibold uppercase tracking-wide text-(--text)`}
                          children={[`Pedidos por resolver (`, n.total, `)`]}
                        />,
                        n.items.map((e) => {
                          let t = e.tipo === `CANCELACION`,
                            n = h[e.id] ?? e.tipoCambio ?? `TARDANZA`;
                          return (
                            <div
                              key={e.id}
                              className={`rounded-2xl border border-(--border) bg-(--bg) p-4 animar-entrada flex flex-wrap items-center gap-2`}
                              children={[
                                t
                                  ? (0, JSXRuntime.jsx)(yr, {
                                      className: `h-4 w-4 shrink-0 text-(--warning)`,
                                    })
                                  : (0, JSXRuntime.jsx)(wr, {
                                      className: `h-4 w-4 shrink-0 text-(--warning)`,
                                    }),
                                <div
                                  className={`min-w-0 flex-1`}
                                  children={[
                                    <Sn
                                      to={mS(e)}
                                      className={`font-medium text-(--text-h) hover:underline`}
                                      children={e.tareaTitulo}
                                    />,
                                    <p
                                      className={`mt-0.5 text-xs text-(--text)`}
                                      children={[
                                        e.solicitanteNombre || `Alguien`,
                                        ` pide `,
                                        t ? `cancelarla` : `mover la fecha`,
                                        ` · `,
                                        pS(e.creadoEn),
                                      ]}
                                    />,
                                    !t && (
                                      <p
                                        className={`mt-0.5 text-xs text-(--text)`}
                                        children={[
                                          e.fechaInicioPropuesta &&
                                            `inicio ${e.fechaInicioPropuesta} `,
                                          e.fechaVencimientoPropuesta &&
                                            `venc. ${e.fechaVencimientoPropuesta}`,
                                          e.fechaVencimientoActual &&
                                            ` (hoy vence ${e.fechaVencimientoActual})`,
                                        ]}
                                      />
                                    ),
                                    <p
                                      className={`mt-1 whitespace-pre-wrap text-sm text-(--text-h)`}
                                      children={e.motivo}
                                    />,
                                    !t && (
                                      <div
                                        className={`mt-2 max-w-xs`}
                                        children={
                                          <SelectorMultiple
                                            value={n}
                                            onChange={(t) =>
                                              g((n) => ({
                                                ...n,
                                                [e.id]: t,
                                              }))
                                            }
                                            opciones={Bx}
                                          />
                                        }
                                      />
                                    ),
                                  ]}
                                />,
                                <button
                                  type={`button`}
                                  disabled={!!p}
                                  onClick={() => w(e, !0, n)}
                                  className={Ro}
                                  children={[
                                    p === `s${e.id}` &&
                                      (0, JSXRuntime.jsx)(ii, {
                                        className: `mr-1 inline h-4 w-4 animate-spin`,
                                      }),
                                    t ? `Aprobar y cancelar` : `Aprobar`,
                                  ]}
                                />,
                                <button
                                  type={`button`}
                                  disabled={!!p}
                                  onClick={() => w(e, !1)}
                                  className={zo}
                                  children={`Rechazar`}
                                />,
                              ]}
                            />
                          );
                        }),
                        <Paginacion
                          pagina={o}
                          tamano={qC}
                          total={n.total}
                          onChange={s}
                        />,
                      ]}
                    />
                  ),
                ]}
              />
            ),
          ]}
        />
      }
    />
  );
}
